/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 15:48:39
 * @LastEditTime: 2020-08-13 10:20:58
 * @Description: 销售项目api
 */
import axios from '@/utils/axios'

export const getSales = (payload) => {
    return axios.get('/sales', {
        params: payload
    })
}

export const getSalesById = (id, data) => {
    return axios.get(`/sales/${id}`, data)
}

export const createSales = (data) => {
    return axios.post(`/sales`, data)
}

export const updateSales = (id, data) => {
    return axios.put(`/sales/${id}`, data)
}

export const updatePriceSales = (id, data) => {
    return axios.put(`/recipeSales/${id}`, data)
}

export const bindSalesWithItemCodeSales = (data) => {
    return axios.post('/bind_sales_with_item_code_sales', data)
}